// Authentic cement tile pigment palette
export const colorPalette = [
  { id: 'white', name: 'Cloud White', hex: '#FFFFFF' },
  { id: 'cream', name: 'Antique Cream', hex: '#FDF6E3' },
  { id: 'sand', name: 'Sahara Sand', hex: '#E6D0B3' },
  { id: 'terracotta', name: 'Terracotta', hex: '#C07A5F' },
  { id: 'brick', name: 'Burnt Brick', hex: '#9A4535' },
  { id: 'wine', name: 'Wine Red', hex: '#6B2C39' },
  { id: 'blush', name: 'Dusty Pink', hex: '#D8A49B' },
  { id: 'sage', name: 'Sage Green', hex: '#9CAF88' },
  { id: 'emerald', name: 'Emerald', hex: '#2E5D4B' },
  { id: 'forest', name: 'Forest', hex: '#1A3C34' },
  { id: 'sky', name: 'Cerulean', hex: '#8FB6D3' },
  { id: 'ocean', name: 'Ocean Blue', hex: '#3B7CA8' },
  { id: 'navy', name: 'Midnight Navy', hex: '#1F2F45' },
  { id: 'lavender', name: 'Grey Lavender', hex: '#9E9DAD' },
  { id: 'slate', name: 'Slate Grey', hex: '#708090' },
  { id: 'charcoal', name: 'Charcoal', hex: '#36454F' },
  { id: 'black', name: 'Carbon Black', hex: '#1A1A1A' },
  { id: 'mustard', name: 'Mustard', hex: '#D8A936' },
];